if (!customElements.get('custom-countdown-process')) {
  class CustomCountdownProcess extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({ mode: 'open' });

      this.container = document.createElement('div');
      this.container.style.display = 'flex';
      this.container.style.height = '6px';
      this.container.style.borderRadius = '16px';
      this.container.style.background = 'linear-gradient(270deg, #FF6F00 0%, #FFAC33 100%)';
      this.container.style.alignItems = 'center';
      this.container.style.position = 'relative';

      this.clockIcon = document.createElement('img');
      this.clockIcon.setAttribute('src', 'https://cdn.shopify.com/s/files/1/0067/6950/8415/files/custom_progress_time.png');
      this.clockIcon.style.width = '13px';
      this.clockIcon.style.position = 'absolute';
      this.clockIcon.style.left = '0%';
      this.clockIcon.style.transition = 'left 1s linear';
      this.clockIcon.style.transform = 'translateX(-50%)';

       // 创建倒计时文本
      this.timeText = document.createElement('span');
      this.timeText.style.right = '10px';
      this.timeText.style.fontSize = '14px';
      this.timeText.style.color = '#FAAC21';
      this.timeText.style.fontFamily = 'Arial, sans-serif';

      this.container.appendChild(this.clockIcon);
      this.shadowRoot.appendChild(this.container);
      this.shadowRoot.appendChild(this.timeText);
    }

    connectedCallback() {
      const countdownTime = parseInt(this.getAttribute('countdown-time')) || 60;  // 新倒计时时间
      const savedTime = parseInt(localStorage.getItem('countdownTimeRemaining'));
      const savedOriginalTime = parseInt(localStorage.getItem('countdownOriginalTime'));

      // 如果原始时间与新的倒计时时间不同，清除 localStorage
      if (!savedOriginalTime || savedOriginalTime !== countdownTime) {
        localStorage.removeItem('countdownTimeRemaining');
        localStorage.setItem('countdownOriginalTime', countdownTime);
      }

      // 使用 localStorage 中的剩余时间（如果有），否则用新倒计时时间
      const remainingTime = localStorage.getItem('countdownTimeRemaining') 
                            ? savedTime 
                            : countdownTime * 60;

      this.startCountdown(remainingTime, countdownTime);
    }

    startCountdown(countdownTime, originalTime) {
      let remainingTime = countdownTime;

      this.container.style.width = `${Math.max(originalTime * 2, 80)}px`;

      if (this.interval) clearInterval(this.interval);

      this.interval = setInterval(() => {
        const progress = ((originalTime * 60 - remainingTime) / (originalTime * 60)) * 100;
        const iconPosition = progress;
        this.clockIcon.style.left = `${iconPosition}%`;

         // 计算倒计时的分钟、秒
        const minutes = Math.floor(remainingTime / 60);
        const seconds = remainingTime % 60;

        // 格式化倒计时显示为 00:00
        this.timeText.textContent = `00:00:${this.formatTime(minutes)}:${this.formatTime(seconds)}`;

        localStorage.setItem('countdownTimeRemaining', remainingTime);
        localStorage.setItem('countdownOriginalTime', originalTime);

        remainingTime--;

        if (remainingTime < 0) {
          remainingTime = originalTime * 60;
        }
      }, 1000);
    }

    // 补充 0 函数，保证显示格式为两位数（例如 01:05）
    formatTime(time) {
      return time < 10 ? `0${time}` : time;
    }
  }

  customElements.define('custom-countdown-process', CustomCountdownProcess);
}

if (!customElements.get('countdown-process')) {
  class CountdownProcess extends HTMLElement {
    constructor() {
      super();

      this.shadow = this.attachShadow({ mode: 'open' });

      // 创建进度条容器
      this.container = document.createElement('div');
      this.container.style.display = 'flex';
      this.container.style.height = '6px';
      this.container.style.width = '80px';
      this.container.style.borderRadius = '16px';
      this.container.style.background = 'linear-gradient(270deg, #FF6F00 0%, #FFAC33 100%)';
      this.container.style.alignItems = 'center';
      this.container.style.position = 'relative';

      // 创建进度条图标
      this.clockIcon = document.createElement('img');
      this.clockIcon.setAttribute('src', 'https://cdn.shopify.com/s/files/1/0067/6950/8415/files/custom_progress_time.png');
      this.clockIcon.style.width = '13px';
      this.clockIcon.style.position = 'absolute';
      this.clockIcon.style.left = '0%';
      this.clockIcon.style.transition = 'left 1s linear';
      this.clockIcon.style.transform = 'translateX(-50%)';
      // 将元素添加到 shadow DOM
      this.container.appendChild(this.clockIcon);
      this.shadow.appendChild(this.container);
    }

    connectedCallback() {
      this.updateProgress();
    }

    // 获取目标时间戳
    getTargetTimestamp(date, time, timezoneOffset) {
      const [day, month, year] = date.split('-');
      const [hour, minute] = time.split(':');
      const targetDate = new Date(year, month - 1, day, hour, minute);
      const targetTimestamp = targetDate.getTime() - (timezoneOffset * 60 * 60 * 1000);
      return targetTimestamp;
    }

    // 获取开始时间戳
    getEndTimestamp(enddate, endtime, timezoneOffset) {
      const [day, month, year] = enddate.split('-');
      const [hour, minute] = endtime.split(':');

      const endDate = new Date(year, month - 1, day, hour, minute);
      const endTimestamp = endDate.getTime() - (timezoneOffset * 60 * 60 * 1000);
      return endTimestamp;
    }

    // 获取当前时间戳（考虑时区偏移）
    getCurrentTimestamp(timezoneOffset) {
      const currentTimestamp = new Date().getTime();
      const adjustedNow = currentTimestamp - (timezoneOffset * 60 * 60 * 1000);
      return adjustedNow;
    }

    // 更新进度条
    updateProgress() {
      const date = this.getAttribute('data-date');
      const time = this.getAttribute('data-time');
      const enddate = this.getAttribute('data-enddate');
      const endtime = this.getAttribute('data-endtime');
      const timezoneOffset = parseInt(this.getAttribute('data-timezone')) || 0;
      this.endTimestamp = this.getEndTimestamp(enddate, endtime, timezoneOffset); 
      this.targetTimestamp =  this.getTargetTimestamp(date, time, timezoneOffset);
      setInterval(() => {
        this.updateProgressBar(timezoneOffset);
      }, 1000);
    }

    // 更新进度条
    updateProgressBar(timezoneOffset) {
      const now = this.getCurrentTimestamp(timezoneOffset);
      const elapsedTime = now - this.endTimestamp;
      const totalDuration =  this.targetTimestamp - this.endTimestamp;
      const progress = Math.min((elapsedTime / totalDuration) * 100, 100);

      const allCountdownElements = document.querySelectorAll('.all_countdowntime');
      if (progress < 0 || progress >= 100 ) {
        allCountdownElements.forEach(element => {
          element.style.display = 'none';
        });
        return;
      }
      allCountdownElements.forEach(element => {
        element.style.display = 'block';
      });
      this.clockIcon.style.left = `${progress}%`;
    }
  }

  // 注册自定义元素
  customElements.define('countdown-process', CountdownProcess);
}
/**
 *  @class
 *  @function CountdownTimer
 */
if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();

      const timezone = this.dataset.timezone,
        date = this.dataset.date.split('-'),
        day = parseInt(date[0]),
        month = parseInt(date[1]),
        year = parseInt(date[2]);

      let time = this.dataset.time,
        tarhour, tarmin;

      if (time != null) {
        time = time.split(':');
        tarhour = parseInt(time[0]);
        tarmin = parseInt(time[1]);
      }



      // Set the date we're counting down to
      let date_string = month + '/' + day + '/' + year + ' ' + tarhour + ':' + tarmin + ' GMT' + timezone;
      // Time without timezone
      this.countDownDate = new Date(year, month - 1, day, tarhour, tarmin, 0, 0).getTime();

      // Time with timezone
      this.countDownDate = new Date(date_string).getTime();

    }

    convertDateForIos(date) {
      var arr = date.split(/[- :]/);
      date = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
      return date;
    }
    connectedCallback() {
      let _this = this;
      const updateTime = function() {

        // Get todays date and time
        const now = new Date().getTime();
        // Find the distance between now an the count down date
        const distance = _this.countDownDate - now + 1800;

        // Time calculations for days, hours, minutes and seconds
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (distance < 0) {
            _this.style.display = 'none';
        } else {
          _this.querySelector('.days .countdown-timer--column--number').innerHTML = CountdownTimer.addZero(days);
          _this.querySelector('.hours .countdown-timer--column--number').innerHTML = CountdownTimer.addZero(hours);
          _this.querySelector('.minutes .countdown-timer--column--number').innerHTML = CountdownTimer.addZero(minutes);
          _this.querySelector('.seconds .countdown-timer--column--number').innerHTML = CountdownTimer.addZero(seconds);
        }

      };
      setInterval(updateTime, 1000);
    }
    static addZero(x) {
      return (x < 10 && x >= 0) ? "0" + x : x;
    }
  }
  customElements.define('countdown-timer', CountdownTimer);
}